import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MD_DESKTOP_WIDTH } from "constants/vp-sizes";
export const StyledSideBySideParagraphAndTagsHomepageFirstFoldComponent = styled.div`
  margin-left: calc(max((100vw - ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px) / 2 + 32px, 32px));
  display: flex;
  gap: ${({ gap })=>gap};
  min-height: ${({ minHeight })=>minHeight};

  .full-paragraph {
    margin-top: ${({ fullParagraphTopMargin })=>fullParagraphTopMargin};
    width: fit-content;
    justify-content: center;
  }

  .tags-and-assets-component {
    flex: 1;
  }

  .clickable-tags-grid {
    gap: calc(min(20 * (100vw / 1920), 20px));
    padding: calc(min(24 * (100vw / 1920), 24px));
    border-radius: calc(min(18 * (100vw / 1920), 18px));

    .animated-text-component, .extra-details .title {
      font-size: calc(max(min(16 * (100vw / 1920), 1rem), 0.8125rem));
    }

    .tags-container {
      grid-gap: calc(min(12 * (100vw / 1920), 12px));

      .tag-component {
        font-size: calc(max(min(14 * (100vw / 1920), 0.875rem), 0.75rem));
        width: calc(max(min(100 * (100vw / 1920), 100px), 80px));
        height: calc(max(min(96 * (100vw / 1920), 96px), 76px));

        .checkbox {
          top: calc(max(min(10 * (100vw / 1920), 10px), 7.5px));
          left: calc(max(min(10 * (100vw / 1920), 10px), 7.5px));
          width: calc(max(min(16 * (100vw / 1920), 16px), 12px));
          height: calc(max(min(16 * (100vw / 1920), 16px), 12px));
          border-radius: calc(max(min(4 * (100vw / 1920), 4px), 2.5px));

          .checkmark svg {
            width: calc(max(min(9 * (100vw / 1920), 9px), 7px));
            height: calc(max((min(8 * (100vw / 1920), 8px)), 6px;));
          }
        }

        .icon {
          svg {
            height: calc(max(min(20 * (100vw / 1920), 20px), 16px));
            width: calc(max(min(20 * (100vw / 1920), 20px), 16px));
          }
        }
      }
    }
  }
`;
